import { Divider, Typography } from '@mui/material';
import { CloseRounded } from '@mui/icons-material';
import { useMyAssortmentTFunction } from '@retail/my-assortment/i18n';
import { DataGridFloatingActionToolbar, TextButton } from '@retail/components';
import { IconButton } from '@retail/products/components';

interface Props {
  checkedItems: number;
  totalItems: number;
  handleAddItems?: () => void;
  resetCheckedItems: () => void;
}

export function CentralAssortmentActionToolbar({
  checkedItems,
  totalItems,
  handleAddItems,
  resetCheckedItems,
}: Props) {
  const t = useMyAssortmentTFunction();

  return (
    <DataGridFloatingActionToolbar>
      <IconButton sx={{ p: 0, ':hover': { color: 'common.black' } }} onClick={resetCheckedItems}>
        <CloseRounded fontSize="small" />
      </IconButton>

      <Divider orientation="vertical" sx={{ height: 'auto' }} />

      <Typography variant="subtitle2" whiteSpace="nowrap">
        {t('myAssortment.nrOfItemsSelected', { items: checkedItems, totalItems })}
      </Typography>

      <Divider orientation="vertical" sx={{ height: 'auto' }} />

      {handleAddItems && (
        <TextButton
          disabled={!checkedItems}
          onClick={handleAddItems}
          sx={{ ':hover': { color: 'common.black' } }}
        >
          {t('myAssortment.actions.addItems')}
        </TextButton>
      )}
    </DataGridFloatingActionToolbar>
  );
}
